import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { Formik, Form, useFormikContext, Field } from "formik";
import { useIntl, defineMessages } from "react-intl";
import { Grid, FormControl, FormHelperText, Dialog, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { TextField, KeyboardDatePickerField } from "@ploy-ui/form-fields";
import { PendingButton } from "@ploy-ui/core";
import { object, string } from "yup";
import { legacyApiResourceUrl } from "@ploy-lib/core";
const messages = defineMessages({
    invalidDate: {
        id: "form_fields.datetimepicker.missing",
        defaultMessage: "Date is missing",
        description: "text for missing date"
    },
    missingPhoneNumber: {
        id: "form_fields.phoneNumber.missing",
        defaultMessage: "Missing mobile number",
        description: "text for missing phone number"
    },
    wrongPhoneNumber: {
        id: "form_fields.phoneNumber.wrong",
        defaultMessage: "Must be in XXXXXXXX format (8 digits)",
        description: "text for wrong phone number"
    }
});
const ProofOfDeliverySmsActions = (props) => {
    const { loadedData, reload, className, reloadData, onClick, regNumber, rowData, errors } = props;
    const intl = useIntl();
    const registrationNumber = rowData?.field8 || regNumber;
    const disableButton = errors ||
        loadedData?.wrongCausalOrder ||
        registrationNumber === undefined ||
        registrationNumber === null ||
        registrationNumber === "";
    const ProofOfDeliverySchema = useMemo(() => object().shape({
        deliveryDate: string().required(intl.formatMessage(messages.invalidDate)),
        phoneNumber: string()
            .matches(/(^[0-9]{8}$)|(^[0-9]{3}[0-9]{2}[0-9]{3}$)/, {
            excludeEmptyString: true,
            message: intl.formatMessage(messages.wrongPhoneNumber)
        })
            .required(intl.formatMessage(messages.missingPhoneNumber))
    }), [intl]);
    if (!loadedData)
        return null;
    return (_jsx(Formik, { initialValues: {
            deliveryDate: loadedData.deliveryDate || "",
            phoneNumber: loadedData.phoneNumber || "",
            applicationId: loadedData.applicationId || ""
        }, onSubmit: async (data, formik) => {
            await onConfirm(data, formik, loadedData);
            await reload?.();
            await reloadData?.();
        }, validationSchema: ProofOfDeliverySchema, enableReinitialize: true, validateOnMount: true, children: ({ isSubmitting, status = {
            ...(loadedData.deliverySent && {
                message: getFormattedConfirmationMessage(loadedData.receiver)
            })
        } }) => {
            return (_jsx(Form, { children: _jsxs(Grid, { container: true, spacing: 2, className: className, onClick: onClick, children: [_jsx(Grid, { item: true, xs: "auto", md: "auto", lg: "auto", children: _jsx(Field, { name: "deliveryDate", label: _jsx(FormattedMessage, { id: "dealer.delivery.date", description: "text for deliverydate", defaultMessage: "Delivery date" }), component: KeyboardDatePickerField, disabled: isSubmitting || disableButton, margin: "normal", variant: "outlined", helperText: " ", fullWidth: true, autoOk: true, allowKeyboardControl: true, format: "long" }) }), _jsx(Grid, { item: true, xs: "auto", md: "auto", lg: "auto", children: _jsx(Field, { name: "phoneNumber", label: _jsx(FormattedMessage, { id: "dealer.mobilenumber", description: "text for mobilenumber", defaultMessage: "Mobile number" }), component: TextField, disabled: isSubmitting || disableButton, margin: "normal", variant: "outlined", helperText: " ", fullWidth: true, type: "tel" }) }), !disableButton && (_jsx(Grid, { item: true, xs: "auto", md: "auto", lg: "auto", children: _jsxs(FormControl, { variant: "standard", margin: "normal", fullWidth: true, children: [_jsx(SubmitButton, { type: "button", variant: "contained", color: "secondary", size: "large", fullWidth: true, children: _jsx(FormattedMessage, { id: "dealer.sendDeliveryOfProof.button.label", description: "Label for send proof of delivery button", defaultMessage: "Send leveringsbevis" }) }), _jsx(FormHelperText, { color: status.success && !status.error ? "inherit" : "error", children: status.error || status.message || " " })] }) }))] }) }));
        } }));
};
const getFormattedConfirmationMessage = (number) => number ? (_jsx(FormattedMessage, { id: "dealer.deliveryOfProofSentSms.withNumber", description: "text for delivery of proof sent with reciever number", defaultMessage: "Leveringsbevis er sendt til: + {number}", values: { number: number } })) : (_jsx(FormattedMessage, { id: "dealer.deliveryOfProofSentSms.withoutNumber", description: "text for delivery of proof sent without reciever number", defaultMessage: "Leveringsbevis er sendt." }));
const onConfirm = async (data, formik, loadedData) => {
    const response = await fetch(legacyApiResourceUrl("ProofOfDelivery/Send"), {
        method: "POST",
        body: new Blob([JSON.stringify(data)], { type: "application/json" }),
        headers: {
            accept: "application/json"
        }
    });
    if (response.ok) {
        formik.setSubmitting(false);
        if (!loadedData.phoneNumber || loadedData.phoneNumber !== data.phoneNumber)
            formik.resetForm();
    }
    else {
        formik.setStatus({
            error: (_jsx(FormattedMessage, { id: "dealer.deliveryOfProof.error", description: "Error text when delivery of proof fails", defaultMessage: "An error has occured" }))
        });
    }
};
export function SubmitButton(props) {
    const formik = useFormikContext();
    const [open, setOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(PendingButton, { pending: formik.isSubmitting, disabled: !formik.isValid, onClick: () => {
                    setOpen(true);
                }, ...props }), _jsx(Dialog, { open: open, children: _jsxs(DialogContent, { children: [_jsx(DialogContentText, { children: _jsx(FormattedMessage, { id: "dealer.deliveryOfProof.dialog.message", description: "DeliveryOfProof dialog message", defaultMessage: "Bekreft utsendelse av leveringsbevis" }) }), _jsxs(DialogActions, { style: { justifyContent: "space-between" }, children: [_jsx(PendingButton, { onClick: () => setOpen(false), children: _jsx(FormattedMessage, { id: "dealer.deliveryOfProof.dialog.cancel.button", description: "Avbryt knapp i deliveryOfProof dialog", defaultMessage: "Cancel" }) }), _jsx(PendingButton, { onClick: () => {
                                        formik.submitForm();
                                        setOpen(false);
                                    }, children: _jsx(FormattedMessage, { id: "dealer.deliveryOfProof.dialog.send.button", description: "Send knapp i deliveryOfProof dialog", defaultMessage: "Send" }) })] })] }) })] }));
}
export { ProofOfDeliverySmsActions };
//# sourceMappingURL=ProofOfDeliverySmsActions.js.map